import React, { useEffect, useState } from 'react';
import { Grid, MenuItem } from '@mui/material';
import CustomFormLabel from '../../components/forms/custom-elements/CustomFormLabel';
import CustomSelect from '../../components/forms/custom-elements/CustomSelect';
import { useSelector } from 'react-redux';
import {
  getAllMinistries,
  getMinistrySubUnitByMinistryDepartmentCode,
  getMinistryDepartmentsByMinistryCode,
} from '../../firebase/functions';

const Ministry = ({
  ministryCode,
  setMinistryCode,
  ministryDepartmentCode,
  setMinistryDepartmentCode,
  ministrySubUnitCode,
  setMinistrySubUnitCode,
}) => {
  const [ministries, setMinistries] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [ministriesSubUnit, setMinistriesSubUnit] = useState([]);
  const profile = useSelector((state) => state.ProfileReducer);

  const getMinistries = async () => {
    try {
      const ministryData = await getAllMinistries();
      setMinistries(
        ministryData
          ?.map((o) => ({ label: o.ministry_name, value: o.ministry_code }))
          .sort((a, b) => a.label.localeCompare(b.label)),
      );
    } catch (error) {
      console.error('Error fetching ministries:', error);
    }
  };

  const getMinistriesDepartments = async (id) => {
    try {
      const ministryUnitData = await getMinistryDepartmentsByMinistryCode(id);
      setDepartments(
        ministryUnitData
          ?.map((o) => ({ label: o.ministry_department_name, value: o.ministry_department_code }))
          .sort((a, b) => a.label.localeCompare(b.label)),
      );
    } catch (error) {
      console.error('Error fetching ministry units:', error);
    }
  };

  const getMinistriesSubUnit = async (id) => {
    try {
      const ministrySubUnitData = await getMinistrySubUnitByMinistryDepartmentCode(id);
      setMinistriesSubUnit(
        ministrySubUnitData
          ?.map((o) => ({ label: o.ministry_unit_name, value: o.ministry_unit_code }))
          .sort((a, b) => a.label.localeCompare(b.label)),
      );
    } catch (error) {
      console.error('Error fetching ministry sub units:', error);
    }
  };

  useEffect(() => {
    if (profile.info?.user_record?.role_id == 2 && profile?.info?.user_details?.length > 0) {
      setMinistryCode(profile?.info?.user_details[0]?.ministry_code);
      getMinistriesDepartments(profile?.info?.user_details[0]?.ministry_code);
    }
    if (profile.info?.user_record?.role_id == 3 && profile?.info?.user_details?.length > 0) {
      getMinistriesDepartments(profile?.info?.user_details[0]?.ministry_code);
      getMinistriesSubUnit(profile?.info?.user_details[0]?.ministry_department_code);
      setMinistryCode(profile?.info?.user_details[0]?.ministry_code);
      setMinistryDepartmentCode(profile?.info?.user_details[0]?.ministry_department_code);
    }
    if (profile.info?.user_record?.role_id == 4 && profile?.info?.user_details?.length > 0) {
      getMinistriesDepartments(profile?.info?.user_details[0]?.ministry_code);
      getMinistriesSubUnit(profile?.info?.user_details[0]?.ministry_department_code);
      setMinistryCode(profile?.info?.user_details[0]?.ministry_code);
      setMinistryDepartmentCode(profile?.info?.user_details[0]?.ministry_department_code);
      setMinistrySubUnitCode(profile?.info?.user_details[0]?.ministry_unit_code);
    }
    if (profile.info?.user_record?.role_id == 13 && profile?.info?.user_details?.length > 0) {
      setMinistryCode(profile?.info?.user_details[0]?.ministry_code);
      getMinistriesDepartments(profile?.info?.user_details[0]?.ministry_code);
    }
  }, [profile?.info]);

  useEffect(() => {
    getMinistries();
  }, []);

  useEffect(() => {
    if (!ministryCode) {
      setDepartments([]);
      setMinistriesSubUnit([]);
    }
    if (!ministryDepartmentCode) {
      setMinistriesSubUnit([]);
    }
  }, [ministryCode, ministryDepartmentCode]);

  const handleChangeMinistryName = (value) => {
    setMinistryCode(value);
    setMinistryDepartmentCode(undefined);
    setMinistrySubUnitCode(undefined);
    getMinistriesDepartments(value);
  };

  const handleChangeMinistryUnitName = (value) => {
    setMinistryDepartmentCode(value);
    setMinistrySubUnitCode(undefined);
    getMinistriesSubUnit(value);
  };

  const handleChangeMinistrySubUnitName = (value) => {
    setMinistrySubUnitCode(value);
  };

  return (
    <>
      {ministries?.length > 0 && (
        <Grid item xs={12} md={3}>
          <CustomFormLabel>Select Ministry</CustomFormLabel>
          <CustomSelect
            value={ministryCode || ''}
            onChange={(e) => handleChangeMinistryName(e.target.value)}
            id="ministry_code"
            fullWidth
            name="ministry_code"
            size="small"
            disabled={
              profile.info?.user_record?.role_id == 2 ||
              profile.info?.user_record?.role_id == 3 ||
              profile.info?.user_record?.role_id == 4 ||
              profile.info?.user_record?.role_id == 13
            }
          >
            <MenuItem value="">
              <em>Select Your Option</em>
            </MenuItem>
            {ministries
              .slice() // create a shallow copy to avoid mutating state
              .sort((a, b) => a.label.localeCompare(b.label))
              .map((data) => (
                <MenuItem value={data.value} key={data.value}>
                  {data.label}
                </MenuItem>
              ))}
          </CustomSelect>
        </Grid>
      )}
      {departments.length > 0 && (
        <Grid item xs={12} md={3}>
          <CustomFormLabel>Select Department</CustomFormLabel>
          <CustomSelect
            value={ministryDepartmentCode || ''}
            onChange={(e) => handleChangeMinistryUnitName(e.target.value)}
            id="ministry_department_code"
            fullWidth
            name="ministry_department_code"
            size="small"
            disabled={
              profile.info?.user_record?.role_id == 3 || profile.info?.user_record?.role_id == 4
            }
          >
            <MenuItem value="">
              <em>Select Your Option</em>
            </MenuItem>
            {departments.map((data) => (
              <MenuItem value={data.value} key={data.value}>
                {data.label}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
      )}
      {ministriesSubUnit.length > 0 && (
        <Grid item xs={12} md={3}>
          <CustomFormLabel>Select Unit Ministry</CustomFormLabel>
          <CustomSelect
            value={ministrySubUnitCode || ''}
            onChange={(e) => handleChangeMinistrySubUnitName(e.target.value)}
            id="ministry_unit_code"
            fullWidth
            name="ministry_unit_code"
            size="small"
            disabled={profile.info?.user_record?.role_id == 4}
          >
            <MenuItem value="">
              <em>Select Your Option</em>
            </MenuItem>
            {ministriesSubUnit.map((data) => (
              <MenuItem value={data.value} key={data.value}>
                {data.label}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
      )}
    </>
  );
};

export default Ministry;
